// ── Proposal range normalization (2026-06 pivot) ────────────────────────────
// THE single normalization helper: a legacy discrete proposed time (no
// end_time, or end == start) reads as a 15-minute range (start + 15).
// Every surface that renders or measures a proposal goes through this —
// no parallel range math anywhere.

// Client-side mirror of the scheduling router's MAX_PROPOSED_TIMES —
// keep the two in sync (statically pinned on both sides).
export const MAX_PROPOSED_TIMES = 5;

export const rangeToMin = (hms) => {
  const [h, m] = String(hms || "0:0").split(":");
  return parseInt(h, 10) * 60 + (parseInt(m, 10) || 0);
};

export function normalizeRange(p) {
  const startMin = rangeToMin(p.start_time);
  const endMin = p.end_time
    ? Math.max(rangeToMin(p.end_time), startMin + 15)
    : startMin + 15;
  return { startMin, endMin };
}

export const fmtMin12 = (min) => {
  const h = Math.floor(min / 60);
  const m = String(min % 60).padStart(2, "0");
  return `${((h + 11) % 12) + 1}:${m} ${h >= 12 ? "PM" : "AM"}`;
};

// "9:00 AM – 12:00 PM"
export function fmtRange(p) {
  const { startMin, endMin } = normalizeRange(p);
  return `${fmtMin12(startMin)} – ${fmtMin12(endMin)}`;
}
